<template>
  <div class="stt-btn-wrap" v-if="support">
    <button type="button" class="stt-btn"
            @mousedown.stop="handlePress"
            @mouseleave.stop="handleStop"
            @touchend.stop="handleStop"
            @touchstart.stop="handlePress"
            @contextmenu.prevent="handleStop"
            @mouseup.stop="handleStop">
    <span class="ready" v-if="ready">
      <svg t="1685677519131" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2372" width="200" height="200"><path d="M516.266667 657.066667c78.933333 0 142.933333-64 142.933333-142.933334V217.6a142.933333 142.933333 0 0 0-285.866667 0v296.533333c0 78.933333 64 142.933333 142.933334 142.933334z m-78.933334-439.466667c0-42.666667 36.266667-78.933333 78.933334-78.933333s78.933333 36.266667 78.933333 78.933333v296.533333c0 42.666667-36.266667 78.933333-78.933333 78.933334s-78.933333-36.266667-78.933334-78.933334V217.6z" fill="#ffffff" p-id="2373"></path><path d="M774.4 409.6c-17.066667 0-32 14.933333-32 32v74.666667c0 125.866667-102.4 228.266667-228.266667 228.266666S288 640 288 514.133333v-74.666666c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v74.666666c0 149.333333 113.066667 273.066667 260.266667 290.133334v85.333333h-117.333334c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h296.533334c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32h-117.333334v-85.333333c145.066667-14.933333 260.266667-140.8 260.266667-290.133334v-74.666666c0-17.066667-12.8-29.866667-32-29.866667z" fill="#ffffff" p-id="2374"></path></svg>
    </span>
      <span class="listening" v-if="listening">
      <svg t="1685677627432" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5077" width="200" height="200"><path d="M469.333333 85.333333m42.666667 0l0 0q42.666667 0 42.666667 42.666667l0 768q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-768q0-42.666667 42.666667-42.666667Z" p-id="5078" fill="#ffffff"></path><path d="M298.666667 256m42.666666 0l0 0q42.666667 0 42.666667 42.666667l0 426.666666q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666666-42.666667l0-426.666666q0-42.666667 42.666666-42.666667Z" p-id="5079" fill="#ffffff"></path><path d="M640 256m42.666667 0l0 0q42.666667 0 42.666666 42.666667l0 426.666666q0 42.666667-42.666666 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-426.666666q0-42.666667 42.666667-42.666667Z" p-id="5080" fill="#ffffff"></path><path d="M810.666667 384m42.666666 0l0 0q42.666667 0 42.666667 42.666667l0 170.666666q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666666-42.666667l0-170.666666q0-42.666667 42.666666-42.666667Z" p-id="5081" fill="#ffffff"></path><path d="M128 384m42.666667 0l0 0q42.666667 0 42.666666 42.666667l0 170.666666q0 42.666667-42.666666 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-170.666666q0-42.666667 42.666667-42.666667Z" p-id="5082" fill="#ffffff"></path></svg>
    </span>
      <span class="loading" v-if="loading">
      <svg t="1685678872899" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6172" width="200" height="200"><path d="M359.850667 726.016c22.058667-23.466667 105.045333-93.141333 106.112-94.037333a46.293333 46.293333 0 0 1 60.074666 0c1.066667 0.896 84.053333 70.570667 106.112 94.037333l0.725334 0.768a24.533333 24.533333 0 0 1-18.133334 41.216H377.258667a24.533333 24.533333 0 0 1-18.133334-41.216l0.725334-0.768z m249.386666-229.248a29.013333 29.013333 0 0 0-10.325333 21.76 29.013333 29.013333 0 0 0 10.325333 21.76c7.168 6.186667 15.402667 13.056 24.149334 20.352 28.288 23.552 63.488 52.864 91.562666 84.394667a28.757333 28.757333 0 0 1-2.432 40.704 29.098667 29.098667 0 0 1-40.96-2.432c-25.173333-28.330667-57.173333-54.954667-85.376-78.421334-8.96-7.466667-17.408-14.506667-25.002666-21.077333-19.2-16.64-30.250667-40.448-30.250667-65.28 0-24.874667 11.008-48.64 30.293333-65.28 7.253333-6.314667 15.36-13.098667 23.893334-20.224 46.933333-39.296 125.568-105.045333 125.568-152.448V235.861333a28.970667 28.970667 0 0 0-29.013334-28.842666H300.288a28.970667 28.970667 0 0 0-29.013333 28.842666v44.714667c0 47.402667 78.634667 113.152 125.610666 152.448 8.533333 7.125333 16.64 13.909333 23.893334 20.181333 19.242667 16.64 30.293333 40.448 30.293333 65.28 0 24.874667-11.050667 48.682667-30.293333 65.322667-7.253333 6.314667-15.36 13.056-23.893334 20.224-46.933333 39.253333-125.568 105.002667-125.568 152.448v44.714667c0 15.872 13.013333 28.842667 29.013334 28.842666h391.338666c16 0 29.013333-12.970667 29.013334-28.842666 0-15.957333 12.970667-28.842667 29.013333-28.842667 15.957333 0 28.970667 12.885333 28.970667 28.842667a86.869333 86.869333 0 0 1-86.997334 86.528H300.288A86.869333 86.869333 0 0 1 213.333333 801.194667V756.48c0-74.325333 84.48-144.981333 146.218667-196.608 8.362667-6.997333 16.298667-13.610667 23.210667-19.584a29.013333 29.013333 0 0 0 10.325333-21.76 29.013333 29.013333 0 0 0-10.325333-21.76c-6.912-5.973333-14.848-12.629333-23.210667-19.626667C297.856 425.514667 213.333333 354.858667 213.333333 280.576V235.861333C213.333333 188.16 252.330667 149.333333 300.288 149.333333h391.381333c47.957333 0 86.997333 38.826667 86.997334 86.528v44.714667c0 74.282667-84.522667 144.981333-146.261334 196.565333-8.362667 6.997333-16.256 13.653333-23.168 19.626667z m-81.92-80.298667c-17.194667 14.933333-42.538667 14.933333-59.733333 0-0.554667-0.426667-20.778667-17.749333-43.818667-38.016-18.048-15.914667-6.954667-45.952 16.981334-45.952h113.365333c23.936 0 35.072 30.037333 17.024 45.952-23.04 20.266667-43.306667 37.546667-43.818667 37.973334z" fill="#ffffff" p-id="6173"></path></svg>
    </span>
    </button>
    <div class="dropdown" :class="{open:showLangSetting}" @click="handleClickLang">
      <span class="selected">{{ selectedLangText }}</span>
      <ul v-if="ready">
        <li @click="changeLang(1)">粵</li>
        <li @click="changeLang(2)">En</li>
        <li @click="changeLang(3)">普</li>
      </ul>
    </div>
  </div>

</template>

<script>
const STATUS_INIT = "init";
const STATUS_READY = "ready";
const STATUS_LISTENING = "listening";

export default {
  name: "STTButton",

  data() {
    return {
      showLangSetting: false,
      timeoutID: 0,
      loading: false,
      selectedLangIndex: 1,
      status: STATUS_INIT,
      handler: null,
    }
  },

  computed: {
    ready() {
      return !this.loading && [STATUS_INIT, STATUS_READY].includes(this.status);
    },
    listening() {
      return !this.loading && this.status === STATUS_LISTENING;
    },
    langMappings() {
      return {
        1: '粵',
        2: 'En',
        3: '普',
      };
    },
    lang() {
      const map = {
        1: "yue-Hant-HK",
        2: "en-US",
        3: "cmn-Hans-CN",
      };
      return map[this.selectedLangIndex];
    },
    selectedLangText() {
      return this.langMappings[this.selectedLangIndex];
    },
    support() {
      return ('webkitSpeechRecognition' in window) || ('SpeechRecognition' in window);
    }
  },

  methods: {
    handlePress() {
      /**
       * @var {SpeechRecognition|webkitSpeechRecognition} handler
       */
      const handler = new (webkitSpeechRecognition || SpeechRecognition)();
      handler.continuous = true;
      handler.interimResults = true;
      handler.lang = this.lang;
      handler.addEventListener("start", this.handleStart);
      handler.addEventListener("result", this.handleResult);
      handler.addEventListener("error", (error) => {
        console.log(error);
      })
      handler.start();
      this.handler = handler;
    },
    changeLang(index) {
      this.selectedLangIndex = index;
    },
    handleStart() {
      console.log('handleStart');
      this.status = STATUS_LISTENING;
    },
    handleStop() {
      if (this.status != STATUS_LISTENING) {
        return;
      }
      console.log('handleStop');
      this.status = STATUS_READY;
      this.loading = true;
      if (this.handler) {
        this.handler.stop();
      }
      this.timeoutID = setTimeout(this.handleFailed, 1000);
    },
    handleFailed() {
      console.log('handleFailed');
      this.loading = false;
    },
    handleResult(event) {
      console.log('handleResult');
      console.log(event);
      if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = 0;
      }
      this.loading = false;
      let final_transcript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          final_transcript += event.results[i][0].transcript;
        }
      }
      this.$emit('transcript', final_transcript);
    },
    handleClickLang() {
      this.showLangSetting = !this.showLangSetting;
    },
  }
}
</script>

<style lang="scss">
.stt-btn-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .stt-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.5;
    border-radius: 50%;
    background: rgba(0,0,0, 0.5);
    border: 0;
    width: 2em;
    height: 2em;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);

    &:hover, &:focus {
      outline: none;
      transition: all 0.5s ease;
      opacity: 1;
    }

    svg {
      width: 1.5em;
      height: auto;
    }
  }

  .dropdown {
    position: relative;
    opacity: 0.5;

    > span {
      cursor: pointer;
      padding: 1em;
      font-size: 0.5em;
    }

    &.open {
      opacity: 1;

      > ul {
        display: flex;
        flex-direction: column;
      }
    }

    > ul {
      display: none;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
      background: white;
      left: 0;
      top: 0;
      position: absolute;
      margin: 0;
      padding: 0;
      list-style: none;

      > li {
        cursor: pointer;
        padding: 0.25em;

        &:hover {
          background: grey;
          color: white;
        }
      }
    }
  }
}

</style>
